<template>
  <div class="d-flex align-center">
    <v-btn
      v-if="item.actions.canEdit"
      color="primary"
      class="mr-2 prd-crud-edit-button px-1"
      x-small
      @click="goToEdit(item.id)"
      depressed
    >
      <v-icon small>mdi-arrow-right-thick</v-icon>
    </v-btn>
    <v-tooltip v-if="item.actions.hasBiennialPeriodicity" bottom>
      <template #activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" class="mr-2 prd-biennial-badge">2</span>
      </template>
      <span>Periodicidad bianual</span>
    </v-tooltip>
    <v-btn
      v-if="item.actions.canDelete"
      tile
      icon
      depressed
      x-small
      color="grey"
      @click="$emit('deleteItem', item.id)"
    >
      <v-icon>mdi-delete</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
    crudActions: { type: Object, required: true },
  },
  methods: {
    goToEdit(itemId) {
      if (!itemId) {
        this.$notifyError(
          null,
          "El elemento que intentas abrir no existe. Recarga la página y vuélvelo a intentar."
        );
        return;
      }
      const routeName = this.$route.name;
      const isTabCrud = routeName.includes("-");
      const editItemRouteName = isTabCrud ? routeName.split("-")[1] + "Edit" : routeName + "Edit";

      this.$router.push({ name: editItemRouteName, params: { id: itemId } });
    },
  },
};
</script>

<style scoped>
.prd-biennial-badge {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #d32f2f;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}
</style>
